export function toPicker(value, timeZone = "Europe/Rome") {
  if (!value) return "";
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    })
      .formatToParts(new Date(value))
      .map((part) => [part.type, part.value]),
  );
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
export function fromPicker(value, timeZone = "Europe/Rome", original) {
  if (!value) return null;
  if (original && toPicker(original, timeZone) === value) return original;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value))
    throw new Error("Seleziona data e ora valide.");
  const wall = Date.parse(`${value}:00Z`);
  if (!Number.isFinite(wall)) throw new Error("Seleziona data e ora valide.");
  const offsets = new Set(
    [-24, 0, 24].map((hours) => {
      const instant = wall + hours * 3600000;
      return Date.parse(`${toPicker(instant, timeZone)}:00Z`) - instant;
    }),
  );
  const matches = [...offsets]
    .map((offset) => new Date(wall - offset).toISOString())
    .filter((instant) => toPicker(instant, timeZone) === value);
  if (!matches.length)
    throw new Error(
      "Questo orario non esiste durante il cambio ora. Seleziona un altro orario.",
    );
  if (matches.length > 1)
    throw new Error(
      "Questo orario si ripete durante il cambio ora. Seleziona un orario fuori da questo intervallo.",
    );
  return matches[0];
}
